import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "user-reverse",
  "use": "user-reverse-usage",
  "viewBox": "0 0 448 448",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 448\" id=\"user-reverse\"><path d=\"M380.75 334.75c-6.5-46.75-25.5-88.25-68-94-22 24-53.75 39.25-88.75 39.25s-66.75-15.25-88.75-39.25c-42.5 5.75-61.5 47.25-68 94C102 383.75 159.25 416 224 416s122-32.25 156.75-81.25zM320 160c0-53-43-96-96-96s-96 43-96 96 43 96 96 96 96-43 96-96zm128 64c0 123.25-100 224-224 224C100.25 448 0 347.5 0 224 0 100.25 100.25 0 224 0s224 100.25 224 224z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/user-reverse.svg
// module id = Y5tN
// module chunks = 1